$(document).ready(function(){
  let currentLang = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/i) ? window.location.pathname.match(/^\/([a-z]{2})(\/|$)/i)[1] : 'fr';
  
  /////////////////// Hidden Preorder btn ///////////////////
  
  // function hiddenBtnPreOrder() {
  //   const addToCartBtn = document.querySelector(".product-form__cart-submit");
  //   const addToCartSpan = document.querySelector(".product-form__cart-submit span");

  //   function checkText() {
  //     if (addToCartSpan.textContent.trim() === "Précommander") {
  //       addToCartBtn.style.visibility = "visible"
  //     }
  //   }

  //   checkText();

  //   // Checks the text each time the tag is modified
  //   const observer = new MutationObserver(checkText);
  //   observer.observe(addToCartBtn, { childList: true, attributes: true, characterData: true, subtree: true });
  // }

  // function isProductPage(url) {
  //   const pattern = /\/products\//i;
  //   return pattern.test(url);
  // }

  // if (isProductPage(window.location.pathname)) {
  //   hiddenBtnPreOrder();
  // }

  //////////////////////////////////////////////////////////
  
  
  /////////////////// Language switch /////////////////// 

  let dropdownLinks = document.querySelectorAll('.dropdown-content a');

  dropdownLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
        event.preventDefault();
        let lang = link.getAttribute('data-lang-switch');
        let url = window.location.pathname;
        let newUrl;

        if (lang === 'fr') {
            if (url.substring(3) === '') {
              newUrl = '/'
            } else {
              newUrl = url.substring(3);
            }
        } else {
            if (url === '/') {
              newUrl = '/' + lang
            } else {
              newUrl = '/' + lang + url
            }
        }

        window.location.href = newUrl;
    });
  });

  //////////////////////////////////////////////////////////

  /////////////////// Translations ///////////////////
  $(".widget-title").text(function () {
    if (currentLang === 'fr') {
      return $(this).text().replace("Size", "Taille");
    }
  });

  $(".cart__meta-text").text(function () {
    if (currentLang === 'fr') {
      return $(this).text().replace("Color", "Couleur");
    }
  });

  $(".widget-title").text(function () {
    if (currentLang === 'fr') {
      return $(this).text().replace("Color", "Couleur");
    }
  });

  $(".widget-title").text(function () {
    if (currentLang === 'fr') {
      return $(this).text().replace("Univers Editorial ", "Univers éditorial");
    }
  });

  function translateColorText() {
    const filterColor = document.querySelector(".filterbar");

    function checkText() {
      const filterColorSpan = document.querySelector(".widget-title span");
      
      if (filterColorSpan) {
        const secondSpan = filterColorSpan.querySelector("span")

        if (secondSpan) {
          filterColorSpan.removeChild(secondSpan);
        }
        
        if (filterColorSpan.textContent.trim() === "Color") {
          if (currentLang === 'fr') {
            filterColorSpan.innerHTML = "Couleur"
          }
        }
      }
    
    }
    
    checkText();

    const observer = new MutationObserver(checkText);
    observer.observe(filterColor, { childList: true, attributes: true, characterData: true, subtree: true });
  }

  if (window.location.pathname === "/collections/consoles" || window.location.pathname === "/collections/accessoires") {
    translateColorText();
  }

  //////////////////////////////////////////////////////////
});